import React from 'react';
import styles from './chatbot.module.scss';

const ChatHeader = ({ isLoading, onStopGenerating, onClose }) => {
    return (
        <div className={styles.header}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <span>AI Assistant</span>
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
                {isLoading && (
                    <button onClick={onStopGenerating} className={styles.closeBtn} title="Stop Generating">
                        <i className="bi bi-stop-circle-fill" style={{ color: '#dc3545' }}></i>
                    </button>
                )}
                <button onClick={onClose} className={styles.closeBtn}>
                    <i className="bi bi-x-lg"></i>
                </button>
            </div>
        </div>
    );
};

export default ChatHeader;